import { render, staticRenderFns } from "./Learn.vue?vue&type=template&id=57a924d6&scoped=true&"
import script from "./Learn.vue?vue&type=script&lang=js&"
export * from "./Learn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a924d6",
  null
  
)

export default component.exports